export const refinancingCarLoanData = [
  {
    id: "step-one",
    stepName: "Refinancing vs. Balance Transfer: What’s the Difference?",
  },
  {
    id: "step-two",
    stepName: "When to Refinance a Personal Loan",
  },
  {
    id: "step-three",
    stepName: "When to Choose a Balance Transfer",
  },
  {
    id: "step-four",
    stepName: "Guide to Decide: Refinance or Balance Transfer?",
  },
  {
    id: "step-five",
    stepName: "How Minemi Helps You Decide",
  },
];

export const getRefinancingLoanData = [
  {
    id: 1,
    heading:
      "Personal Loan Refinance Calculator: Simplify Your Loan Repayments",
    subHeading:
      "Refinancing your personal loan can help you save money by reducing your monthly payments, lowering your interest rate, or restructuring your loan tenure. However, refinancing and balance transfer are often used interchangeably, which can confuse borrowers. Here’s a clear guide to help you decide between refinancing and balance transfer, along with when to use each.",
    notice:
      "Whether you need to refinance your personal loan or opt for a balance transfer, Minemi’s tools and resources make the process seamless. Start exploring your options today to save money and simplify your financial life!",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
